export default __webpack_public_path__ + "static/media/moon.1a1d31a0.svg";